// @flow

import React from 'react';
import { toastr } from 'react-redux-toastr';
import styles from './editPaymentDetailsModal.scss';
import Modal from '../modal/modal';
import {
  roundOff,
  paymentTypeMap,
  isValidUtrNo,
  isTanNumberValid,
  validateMobileNumber
} from '../../../services/helpers';
import InputField from '../formElements/inputField/inputField';
import Select from '../formElements/select/select';
import ImageUpload from '../imageUpload/imageUpload';
import {
  paymentStatusRespEnum,
  paymentModeDisplayNameToEnumMap
} from './editPaymentDetailsHelper';

import { debounce } from '../../../services/helpers';
import Loader from '../loader/loader';
import loaderImgUrl from '../../../assets/images/input_loader.gif';
import confirmedImgUrl from '../../../assets/images/success-tick.png';

type Props = {
  showModal: boolean,
  closeModal: Function,
  modalTheme: Object,
  modalTitle: string,
  editPaymentDetailsSubmitData: Object,
  editPaymenPrefillData: Object,
  submitAction: Function,
  getBankDetails: Function,
  getRivigoBankDetails: Function,
  bankData: Object,
  getAllowedPaymentTypes: Function,
  allowedPaymentTypes: Object,
  getChequeNumberAction: Function,
  getShortPaymentReasons: Function,
  shortPaymentReasons: Object,
  initiateOnlinePayment: Function,
  checkOnlinePaymentStatus: Function,
  resendPaymentLink: Function,
  cancelOnlinePayment: Function
};

type State = {
  showTDSsection: boolean,
  showChequeDetailsSection: boolean,
  showChequeDetailsOption: boolean,
  showBankTransferDetailsSection: boolean,
  tinNo: string,
  paymentMode: string,
  chequeNo: string,
  transactionReferenceNo: string,
  selectedBank: Object,
  tdsApplied: boolean,
  totalAmount: number,
  cnNo: number,
  chequeImage: Object,
  chequeNum: string,
  isChequeUploaded: boolean,
  ocrChequeNumber: string,
  shortPaymentAmount: number,
  shortPaymentTanNumber: string,
  isTanAlreadyAvailable: boolean,
  isShortPayment: boolean,
  isUtrNoFetched: boolean,
  isUtrDetailPresent: boolean,
  isLoading: boolean,
  isOnlinePaymentConfirmed: boolean,
  isOnlinePaymentInProgress: boolean,
  phoneNumberforLink: string,
  changeNumberModal: boolean,
  transactionId: number,
  loading: boolean,
  changeNumberInput: String,
  isPaymentConfirmed: boolean,
  resendBtnDisable: boolean,
  isChequeNumberCorrect: boolean,
  showOcrSection: boolean,
  transferredAmount: String,
  selectedRivigoBank: Object
};

const COLLECTION_DEDUCTION_ID = 156;

class EditPaymentDetailsModal extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = {
      showTDSsection: false,
      showChequeDetailsSection: false,
      showChequeDetailsOption: true,
      showBankTransferDetailsSection: false,
      showOnlineSection: false,
      tinNo: '',
      paymentMode: paymentTypeMap.CASH.key,
      chequeNo: '',
      totalAmount: 0,
      transactionReferenceNo: '',
      selectedBank: null,
      cnNo: null,
      tdsApplied: false,
      transactionScreenshotMultipartFile: null,
      tanCertificateMultipartFile: null,
      isTanAlreadyAvailable: false,
      chequeImage: null,
      isChequeNumberCorrect: true,
      isChequeUploaded: false,
      transferredAmount: null,
      ocrChequeNumber: null,
      showOcrSection: true,
      isUtrNoFetched: false,
      isUtrDetailPresent: false,
      selectedReasonForShortPayment: null,
      shortPaymentAmount: 0,
      shortPaymentTanNumber: '',
      isShortPayment: false,
      isOnlinePaymentConfirmed: false,
      isOnlinePaymentInProgress: false,
      changeNumberModal: false,
      phoneNumberforLink: '',
      transactionId: 0,
      isLoading: false,
      changeNumberInput: '',
      resendBtnDisable: true
    };
    this.bankNameValKeys = { nameKey: 'fullName', valKey: 'fullName' };
    this.rivigoBankNameValKeys = { nameKey: 'bankName', valKey: 'bankName' };
    this.shortPaymentReasonsNameValKeys = {
      nameKey: 'reason',
      valKey: 'reason'
    };
    this.debounceInterval = 500;
    this.getUtrDetails = debounce(this.getUtrDetails, this.debounceInterval);
    this.interval = null;
    this.resendTimer = 30000;
    this.checkStatusInterval = 5000;
  }

  handleWindowClose = ev => {
    const { isOnlinePaymentInProgress, loading } = this.state;
    if (loading || isOnlinePaymentInProgress) {
      ev.preventDefault();
      ev.returnValue = 'Payment in progress, Please dont refresh or close';
      return ev.returnValue;
    }
    return null;
  };

  componentDidMount() {
    this.props.getBankDetails();
    this.props.getRivigoBankDetails();
    this.props.getShortPaymentReasons();
    window.addEventListener('beforeunload', this.handleWindowClose);
    window.addEventListener('unload', this.handleWindowClose);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleWindowClose);
    window.removeEventListener('unload', this.handleWindowClose);
  }

  componentWillReceiveProps(nextProps: Object) {
    const { tdaApplicableData } = nextProps;

    // after hitting the `/tds-applicable` api,
    // props are being updated based on availability of tan number
    // if available then tan certificate donot need to be uploaded
    // otherwise user has to upload the tan certificate
    if (
      tdaApplicableData &&
      tdaApplicableData.data &&
      tdaApplicableData.data.status
    ) {
      nextProps.editPaymenPrefillData.isShortPayment = true;
      nextProps.editPaymenPrefillData.shortPaymentReasonId = COLLECTION_DEDUCTION_ID;

      if (tdaApplicableData.data.status === 'success') {
        const { data } = tdaApplicableData;
        nextProps.editPaymenPrefillData.tan =
          data && data.val && data.val.tan ? data.val.tan : null;
      }
    }

    if (
      nextProps.editPaymentDetailsSubmitData &&
      nextProps.editPaymentDetailsSubmitData.preventResetData
    ) {
      return;
    }
    this.initState();
    this.setPrefillValues(nextProps.editPaymenPrefillData);
    this.showToast(nextProps);
    if (!this.isChequeAllowed(nextProps.allowedPaymentTypes)) {
      this.showChequeDetailsOption(false);
    }
    if (
      this.props.editPaymenPrefillData &&
      nextProps.editPaymenPrefillData &&
      nextProps.editPaymenPrefillData.paymentMode &&
      nextProps.editPaymenPrefillData.totalAmount &&
      this.props.editPaymenPrefillData.paymentMode !==
        nextProps.editPaymenPrefillData.paymentMode &&
      this.props.editPaymenPrefillData.totalAmount !==
        nextProps.editPaymenPrefillData.totalAmount
    ) {
      this.props.getAllowedPaymentTypes(
        paymentModeDisplayNameToEnumMap[
          nextProps.editPaymenPrefillData.paymentMode
        ],
        nextProps.editPaymenPrefillData.totalAmount
      );
    }
  }

  onBankSelect(val: string, obj: Object) {
    if (!obj) {
      return;
    }
    this.setState({
      selectedBank: obj
    });
  }

  onRivigoBankSelect(val: string, obj: Object) {
    if (!obj) {
      return;
    }
    this.setState({
      selectedRivigoBank: obj
    });
  }

  getSelectedBank(bankName) {
    const { bankData } = this.props;
    let toreturn;
    if (bankData && bankData.data && bankData.data.val) {
      const banks = bankData.data.val;
      banks.map(bank => {
        if (bank.name === bankName) {
          toreturn = bank;
        }
        return bank; // for eslint
      });
    }
    return toreturn;
  }

  getSelectedShortPaymentReason(shortPaymentReasonId) {
    let toreturn = null;
    if (
      this.props.shortPaymentReasons &&
      this.props.shortPaymentReasons.data &&
      this.props.shortPaymentReasons.data.val
    ) {
      const shortPaymentReasons = this.props.shortPaymentReasons.data.val;
      shortPaymentReasons.map(reason => {
        if (reason.id === shortPaymentReasonId) {
          toreturn = reason;
        }
        return toreturn; // for eslint
      });
    }
    return toreturn;
  }

  setPrefillValues(data: Object) {
    const selectedBank = this.getSelectedBank(data.bankName);
    const selectedReasonForShortPayment = this.getSelectedShortPaymentReason(
      data.shortPaymentReasonId
    );
    // toUpperCase is being done for paymentType as a hack until data sent in getCollectionsSummary call is not fixed
    this.setState({
      selectedBank,
      selectedReasonForShortPayment,
      paymentMode: data.paymentType && data.paymentType.toUpperCase(),
      totalAmount: data.totalAmount,
      chequeNo: data.chequeNumber,
      cnNo: data.consignmentId,
      ocrChequeNumber: null,
      isTanAlreadyAvailable: data.shortPaymentTan ? true : false,
      isChequeNumberCorrect: false,
      showOcrSection: data.chequeNumber ? false : true,
      chequeImage: null,
      isChequeUploaded: data.chequeNumber ? true : false,
      isShortPayment: data.isShortPayment,
      shortPaymentAmount: data.shortPaymentAmount || 0,
      shortPaymentTanNumber: data.shortPaymentTan || '',
      alreadySubmittedTan: data.shortPaymentTan || ''
    });
    if (
      data.paymentType &&
      data.paymentType.toUpperCase() === paymentTypeMap.CHEQUE.key
    ) {
      this.showPaymentModeDetailsSection(paymentTypeMap.CHEQUE.key);
      if (selectedBank) {
        this.onBankSelect(selectedBank.name, selectedBank);
      }
    }
  }
  setTINNo(val: string) {
    this.setState({
      tinNo: val
    });
  }
  setChequeNo(val: string) {
    this.setState({
      chequeNo: val
    });
  }
  setTransactionReferenceNo(val: string) {
    this.setState({
      transactionReferenceNo: val
    });
  }
  setTransferredAmount(val: string) {
    val = val ? parseFloat(val) : '';
    this.setState({
      transferredAmount: val
    });
  }
  setTransactionScreenshotImageFile(file) {
    this.setState({
      transactionScreenshotMultipartFile: file
    });
  }

  setTanCertificateImageFile(file) {
    this.setState({
      tanCertificateMultipartFile: file
    });
  }

  setChequeImageFile(file) {
    this.setState(
      {
        isChequeUploaded: false,
        chequeNo: null,
        isLoading: true,
        chequeImage: file
      },
      () => {
        this.props.getChequeNumberAction(file, ({ ocrChequeNumber }) => {
          if (ocrChequeNumber) {
            this.setState({
              ocrChequeNumber,
              isChequeUploaded: true,
              isChequeNumberCorrect: true,
              showOcrSection: true,
              isLoading: false
            });
          } else {
            this.setState({
              isChequeUploaded: true,
              ocrChequeNumber: null,
              isChequeNumberCorrect: false,
              showOcrSection: false,
              isLoading: false
            });
          }
        });
      }
    );
  }

  rivigoBanksToDisplayAccessor(elem: Object) {
    return `${elem.bankName} (${elem.accountNumber})`;
  }

  rivigoBanksFilterOnSearch(elem: Object, searchStr: String) {
    return (
      elem.bankName.toLowerCase().indexOf(searchStr) >= 0 ||
      elem.accountNumber.toLowerCase().indexOf(searchStr) >= 0
    );
  }

  isChequeAllowed(allowedPaymentTypes) {
    return (
      allowedPaymentTypes &&
      allowedPaymentTypes.data &&
      allowedPaymentTypes.data.val &&
      allowedPaymentTypes.data.val.length &&
      allowedPaymentTypes.data.val.indexOf(paymentTypeMap.CHEQUE.key) > -1
    );
  }

  isCashAllowed(allowedPaymentTypes) {
    return (
      allowedPaymentTypes &&
      allowedPaymentTypes.data &&
      allowedPaymentTypes.data.val &&
      allowedPaymentTypes.data.val.length &&
      allowedPaymentTypes.data.val.indexOf(paymentTypeMap.CASH.key) > -1
    );
  }

  initState() {
    this.setState({
      showTDSsection: false,
      showChequeDetailsSection: false,
      showChequeDetailsOption: true,
      showBankTransferDetailsSection: false,
      tinNo: '',
      paymentMode: paymentTypeMap.CASH.key,
      chequeNo: '',
      totalAmount: 0,
      selectedBank: {},
      cnNo: null,
      tdsApplied: false,
      transactionScreenshotMultipartFile: null,
      tanCertificateMultipartFile: null,
      isChequeNumberCorrect: true
    });
  }

  showToast(nextProps: Object) {
    if (
      nextProps.editPaymentDetailsSubmitData.data.status !== null &&
      this.props.editPaymentDetailsSubmitData.data.status !==
        nextProps.editPaymentDetailsSubmitData.data.status
    ) {
      const { status } = nextProps.editPaymentDetailsSubmitData.data;
      if (status === 'success') {
        toastr.success(
          'Success',
          nextProps.editPaymentDetailsSubmitData.data.val
        );
        this.closeModal(false, true);
      } else if (status === 'failure' || status === 'exception') {
        toastr.error('Error', nextProps.editPaymentDetailsSubmitData.data.val);
      } else {
        toastr.error('Error', 'Error in submitting payment data');
      }
    }
  }

  applyTINno() {
    // calculate tds amt
    // const amount = this.props.something
    // const tdsamount = 2*amount/100;
    // const netAmt = amount - tdsamount

    this.setState({
      tdsApplied: true
    });
  }

  getUtrDetails() {
    if (isValidUtrNo(this.state.transactionReferenceNo)) {
      this.setState(
        {
          isUtrDetailPresent: false,
          isUtrNoFetched: false,
          isLoading: true
        },
        () => {
          this.props.getUtrDetails(
            this.state.transactionReferenceNo,
            details => {
              let selectedRivigoBankLocal = null;
              if (details && details.isUtrDetailPresent) {
                this.props.rivigoBankData.data.val.forEach(bank => {
                  if (bank.id == details.bankAccountReference) {
                    selectedRivigoBankLocal = bank;
                  }
                });
                this.setState({
                  transferredAmount: details.transferredAmount || '',
                  selectedRivigoBank: selectedRivigoBankLocal,
                  isUtrDetailPresent: true,
                  isUtrNoFetched: true,
                  isLoading: false
                });
              } else {
                this.setState({
                  transferredAmount: '',
                  selectedRivigoBank: null,
                  isUtrDetailPresent: false,
                  isUtrNoFetched: true,
                  isLoading: false
                });
              }
            }
          );
        }
      );
    }
  }

  // checking if the selected reason (for short payment) is: TDS not marked at time of handover (id: 153)
  isSelectedReasonCollectionDeduction() {
    return (
      this.state.selectedReasonForShortPayment &&
      this.state.selectedReasonForShortPayment.id === COLLECTION_DEDUCTION_ID
    );
  }

  submitPaymentDetails() {
    if (this.isSelectedReasonCollectionDeduction()) {
      if (
        !this.state.tanCertificateMultipartFile &&
        !this.state.isTanAlreadyAvailable
      ) {
        toastr.error('Error', 'Please upload tan Certificate');
        return;
      }

      if (
        !this.state.shortPaymentTanNumber ||
        shortPaymentTanNumber.length === 0
      ) {
        toastr.error('Error', `Please enter the TAN number`);
        return;
      }

      if (!isTanNumberValid(this.state.shortPaymentTanNumber)) {
        toastr.error('Error', `Please enter the valid TAN number`);
        return;
      }
    }

    if (
      this.state.paymentMode &&
      this.state.paymentMode.toUpperCase() === paymentTypeMap.CHEQUE.key
    ) {
      if (!this.state.selectedBank) {
        toastr.error('Error', 'Please select a bank');
        return;
      }
      if (
        (this.state.isChequeNumberCorrect && !this.state.ocrChequeNumber) ||
        (!this.state.isChequeNumberCorrect && !this.state.chequeNo)
      ) {
        toastr.error('Error', 'Please enter a valid cheque number');
        return;
      }
    }
    if (
      this.state.paymentMode &&
      this.state.paymentMode.toUpperCase() === paymentTypeMap.BANK_TRANSFER.key
    ) {
      if (!isValidUtrNo(this.state.transactionReferenceNo)) {
        toastr.error('Error', 'Please enter a valid UTR number');
        return;
      }
      if (!this.state.selectedRivigoBank) {
        toastr.error('Error', 'Please select a bank');
        return;
      }
      if (!this.state.transferredAmount) {
        toastr.error('Error', 'Please enter a valid transaction amount');
        return;
      }
      if (!this.state.transactionScreenshotMultipartFile) {
        toastr.error('Error', 'Please add transaction screenshot');
        return;
      }
      if (this.state.isShortPayment) {
        if (!this.state.selectedReasonForShortPayment) {
          toastr.error('Error', 'Please select short payment reason');
          return;
        }
        if (
          !this.state.shortPaymentAmount ||
          Number(this.state.shortPaymentAmount) >
            Number(this.props.editPaymenPrefillData.totalRoundOffAmount)
        ) {
          toastr.error(
            'Error',
            `Please enter short payment amount which is not greater than ${this.props.editPaymenPrefillData.totalRoundOffAmount}`
          );
          return;
        }
      }
    }
    const submitObj = {
      consignmentId: this.state.cnNo,
      paymentType: this.state.paymentMode,
      bankName:
        this.state.paymentMode === paymentTypeMap.CHEQUE.key
          ? this.state.selectedBank && this.state.selectedBank.name
          : this.state.selectedRivigoBank &&
            this.state.selectedRivigoBank.bankName,
      chequeNumber: this.state.chequeNo || this.state.ocrChequeNumber,
      transactionReferenceNo: this.state.transactionReferenceNo,
      transferredAmount: this.state.transferredAmount,
      bankAccountReference:
        this.state.selectedRivigoBank && this.state.selectedRivigoBank.id,
      tinNo: this.state.tinNo,
      ocrChequeNumber: this.state.ocrChequeNumber,
      userInputOnOCR: this.state.isChequeNumberCorrect,
      isShortPayment: this.state.isShortPayment,
      shortPaymentReasonId: this.state.isShortPayment
        ? this.state.selectedReasonForShortPayment.id
        : null,
      shortPaymentReason: this.state.isShortPayment
        ? this.state.selectedReasonForShortPayment.reason
        : null,
      shortPaymentAmount: this.state.isShortPayment
        ? this.state.shortPaymentAmount
        : null,
      shortPaymentTan: this.state.shortPaymentTanNumber
        ? this.state.shortPaymentTanNumber
        : null
    };

    // eslint-disable-next-line
    let file = this.state.transactionScreenshotMultipartFile;

    let tanCertificateFile = this.state.tanCertificateMultipartFile;
    if (this.state.paymentMode === paymentTypeMap.CHEQUE.key) {
      file = this.state.chequeImage;
    }

    this.props.submitAction(submitObj, file, tanCertificateFile);
  }

  showChequeDetailsOption(val: boolean) {
    this.setState({
      showChequeDetailsOption: val
    });
  }

  showPaymentModeDetailsSection(paymentMode: String) {
    switch (paymentMode) {
      case paymentTypeMap.CHEQUE.key:
        this.setState({
          showChequeDetailsSection: true,
          showBankTransferDetailsSection: false,
          showOnlineSection: false,
          paymentMode: paymentTypeMap.CHEQUE.key
        });
        break;
      case paymentTypeMap.CASH.key:
        this.setState({
          showChequeDetailsSection: false,
          showBankTransferDetailsSection: false,
          showOnlineSection: false,
          paymentMode: paymentTypeMap.CASH.key
        });
        break;
      case paymentTypeMap.BANK_TRANSFER.key:
        this.setState({
          showChequeDetailsSection: false,
          showBankTransferDetailsSection: true,
          showOnlineSection: false,
          paymentMode: paymentTypeMap.BANK_TRANSFER.key
        });
        break;
      case paymentTypeMap.ONLINE.key:
        this.setState({
          showChequeDetailsSection: false,
          showBankTransferDetailsSection: false,
          paymentMode: paymentTypeMap.ONLINE.key
        });
        break;

      default:
        this.setState({
          showChequeDetailsSection: false,
          showBankTransferDetailsSection: false,
          paymentMode: paymentTypeMap.CASH.key
        });
        break;
    }
    this.setState({});
  }
  toggleTDSsection() {
    this.setState({
      showTDSsection: !this.state.showTDSsection,
      tdsApplied: false
    });
  }

  closeModal(openCloseFlag, refreshFlag) {
    const { isOnlinePaymentInProgress, isPaymentConfirmed } = this.state;
    if (isOnlinePaymentInProgress && !isPaymentConfirmed) {
      alert('Payment in progress, Please wait');
      return;
    }
    this.setState({
      transactionReferenceNo: null,
      isUtrNoFetched: false,
      isOnlinePaymentInProgress: false,
      phoneNumberforLink: '',
      changeNumberModalModal: false,
      isOnlinePaymentConfirmed: false,
      transactionId: '',
      isPaymentConfirmed: false,
      loading: false
    });
    clearInterval(this.interval);
    this.props.closeModal(openCloseFlag, refreshFlag);
  }

  handleGetChequeNumber = () => {
    this.props.getChequeNumberAction(this.state.chequeImage);
    this.setState({ chequeImage: null, isChequeUploaded: true });
  };

  handleSetChequeNumber = () => {
    const { chequeNumber } = this.props;
    if (
      chequeNumber !== '' &&
      this.state.chequeNo !== chequeNumber &&
      this.state.isChequeNumberIncorrect === '' &&
      this.state.isChequeUploaded
    ) {
      this.setChequeNo(chequeNumber);
    }
  };
  onChequeNumberRadioChange = val => {
    this.setState({
      isChequeNumberCorrect: val,
      chequeNo: null
    });
  };

  isOnlinePaymentConfirmationModalSelected = () => {
    if (
      this.state.paymentMode &&
      this.state.paymentMode.toUpperCase() === paymentTypeMap.ONLINE.key &&
      this.state.isOnlinePaymentConfirmed
    ) {
      return true;
    }
    return false;
  };

  resendLink() {
    const { transactionId } = this.state;
    this.setState({ loading: true, resendBtnDisable: true });
    this.props.resendPaymentLink(transactionId, response => {
      this.setState({ loading: false });
      if (response.status === 'SUCCESS') {
        setTimeout(() => {
          this.setState({ resendBtnDisable: false });
        }, this.resendTimer);
      } else {
        this.setState({ resendBtnDisable: false });
      }
    });
  }

  sendLinkonNewMobile() {
    const { changeNumberInput } = this.state;
    if (!validateMobileNumber(changeNumberInput)) {
      toastr.info('Wrong format', 'Please enter a valid 10 digit Number');
    } else {
      this.setState({ loading: true });
      this.stopCheckPaymentStatusLooper();
      this.cancelOnlinePayment();
    }
  }

  // check payment status after time 'checkInterval' ms and closes modal after payment completed

  checkPaymentStatus() {
    const { transactionId } = this.state;
    const { checkOnlinePaymentStatus } = this.props;
    checkOnlinePaymentStatus(transactionId, response => {
      if (response && response.status === paymentStatusRespEnum.COMPLETED) {
        this.onlinePaymentConfirmed();
      } else if (
        response &&
        response.status === paymentStatusRespEnum.CANCELLED
      ) {
        toastr.error('Payment Aborted', 'User cancelled the transaction');
        stopCheckPaymentStatusLooper();
        this.setState({ isOnlinePaymentInProgress: false, loading: false });
      }
    });
  }

  startCheckPaymentStatusLooper() {
    this.interval = setInterval(() => {
      this.checkPaymentStatus();
    }, this.checkStatusInterval);
  }

  stopCheckPaymentStatusLooper() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  cancelOnlinePayment = () => {
    const { transactionId, changeNumberInput } = this.state;
    const { cancelOnlinePayment } = this.props;
    cancelOnlinePayment(transactionId, response => {
      if (response && response.status === paymentStatusRespEnum.CANCELLED) {
        this.setState({ phoneNumberforLink: changeNumberInput });
        this.initiatePayment();
      } else {
        toastr.error('Error', 'Could Not cancel last payment link');
        this.setState({ loading: false });
        this.startCheckPaymentStatusLooper();
      }
    });
  };

  initiatePayment = () => {
    const { editPaymenPrefillData, initiateOnlinePayment } = this.props;
    const {
      totalAmount,
      phoneNumberforLink,
      isOnlinePaymentConfirmed,
      changeNumberModal
    } = this.state;
    if (isOnlinePaymentConfirmed) {
      this.setState({ loading: true });
      initiateOnlinePayment(
        {
          consignmentId: editPaymenPrefillData.consignmentId,
          mobileNumber: phoneNumberforLink,
          totalAmount: roundOff(totalAmount || 0),
          changeNumberModal
        },
        response => {
          this.setState({ loading: false, changeNumberModal: false });
          if (response && response.status === paymentStatusRespEnum.INITIATED) {
            const onlinePaymentResponseDto = response;
            this.onlinePaymentInitiated(onlinePaymentResponseDto);
          } else if (
            response &&
            response.status === paymentStatusRespEnum.COMPLETED
          ) {
            toastr.info(
              'Info',
              'Payment for this CN has been received already'
            );
            this.onlinePaymentConfirmed();
          }
        }
      );
    } else {
      this.setState({
        isOnlinePaymentConfirmed: true
      });
    }
  };

  onlinePaymentInitiated(onlinePaymentResponseDto) {
    this.setState({
      transactionId: onlinePaymentResponseDto.id,
      isOnlinePaymentInProgress: true,
      phoneNumberforLink: onlinePaymentResponseDto.mobileNumber
    });
    this.startCheckPaymentStatusLooper();
    setTimeout(() => {
      this.setState({ resendBtnDisable: false });
    }, this.resendTimer);
  }

  onlinePaymentConfirmed() {
    this.stopCheckPaymentStatusLooper();
    this.setState({ isPaymentConfirmed: true });
    this.submitPaymentDetails();
  }

  renderShortPaymentSection = () => {
    const { shortPaymentReasons } = this.props;
    let shortPaymentReasonOptions = [];
    if (
      shortPaymentReasons &&
      shortPaymentReasons.data &&
      shortPaymentReasons.data.val
    ) {
      shortPaymentReasonOptions = shortPaymentReasons.data.val;
    }
    return (
      <div>
        <div className={styles.shortPayment}>
          <div>Short Payment</div>
          <div
            className="box"
            onClick={() => {
              this.setState(prevState => {
                return Object.assign({
                  isShortPayment: !prevState.isShortPayment
                });
              });
            }}
          >
            {this.state.isShortPayment && <div className="active"></div>}
          </div>
        </div>
        {this.state.isShortPayment && (
          <div>
            <Select
              label="Choose short payment reason"
              nameValStrings={this.shortPaymentReasonsNameValKeys}
              optionsArrOfObj={shortPaymentReasonOptions}
              selectedOpt={this.state.selectedReasonForShortPayment}
              onSelect={(val, obj) => {
                this.setState(
                  {
                    selectedReasonForShortPayment: obj
                  },
                  () => {
                    if (
                      obj.id === COLLECTION_DEDUCTION_ID &&
                      this.props.editPaymenPrefillData
                    ) {
                      this.props.makeTdsApplicableCall(
                        this.props.editPaymenPrefillData.clientNumber,
                        this.props.editPaymenPrefillData.paymentMode ===
                          'TO_PAY'
                      );
                    }
                  }
                );
              }}
              enableSearch={true}
              disableNone={true}
            />
            {this.isSelectedReasonCollectionDeduction() ? (
              <div>
                <InputField
                  inputClassName={`${styles.shortPaymentInput}`}
                  id="shortPaymentTanNumber"
                  allowedInputKeys="str"
                  maxLength="10"
                  value={this.state.shortPaymentTanNumber}
                  onChange={val => {
                    let isTanAlreadyAvailable = false;
                    if (
                      val &&
                      this.state.alreadySubmittedTan &&
                      val === this.state.alreadySubmittedTan
                    ) {
                      isTanAlreadyAvailable = true;
                    }
                    this.setState({
                      shortPaymentTanNumber: val,
                      isTanAlreadyAvailable
                    });
                  }}
                  placeholder={'TAN Number'}
                />
              </div>
            ) : null}
            {this.isSelectedReasonCollectionDeduction() &&
            !this.state.isTanAlreadyAvailable ? (
              <div className={`${styles.chequeUploadDiv}`}>
                <ImageUpload
                  id="tanCertificate"
                  setImageFile={file1 => {
                    this.setTanCertificateImageFile(file1);
                  }}
                  uploadButtonString="Upload TAN Certificate"
                  reUploadButtonString="Re-upload TAN Certificate"
                />
              </div>
            ) : null}
            <div>
              <InputField
                inputClassName={`${styles.shortPaymentInput}`}
                id="shortPaymentAmount"
                allowedInputKeys="decimalnumber"
                value={this.state.shortPaymentAmount}
                onChange={val => {
                  this.setState({
                    shortPaymentAmount: val
                  });
                }}
                placeholder={'Short Payment Amount'}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  bankNameValKeys: Object;
  rivigoBankNameValKeys: Object;

  render() {
    const {
      showTDSsection,
      showChequeDetailsSection,
      showChequeDetailsOption,
      showBankTransferDetailsSection,
      paymentMode,
      chequeNo,
      transactionReferenceNo,
      selectedBank,
      tdsApplied,
      totalAmount,
      chequeImage,
      isChequeUploaded,
      ocrChequeNumber,
      isUtrNoFetched,
      isUtrDetailPresent,
      phoneNumberforLink,
      isOnlinePaymentInProgress,
      changeNumberModal,
      loading,
      isLoading,
      changeNumberInput,
      isPaymentConfirmed,
      resendBtnDisable,
      isChequeNumberCorrect,
      showOcrSection,
      transferredAmount,
      selectedRivigoBank,
      selectedReasonForShortPayment,
      shortPaymentAmount
    } = this.state;

    let finalTotalAmount = totalAmount;

    const {
      showModal,
      modalTheme,
      modalTitle,
      editPaymentDetailsSubmitData,
      bankData,
      allowedPaymentTypes,
      rivigoBankData
    } = this.props;

    if (
      selectedReasonForShortPayment &&
      selectedReasonForShortPayment.id === COLLECTION_DEDUCTION_ID
    ) {
      finalTotalAmount = roundOff(
        (finalTotalAmount || 0) - (shortPaymentAmount || 0)
      );
    }

    return (
      <Modal
        showLoader={
          editPaymentDetailsSubmitData.isLoading ||
          bankData.isLoading ||
          allowedPaymentTypes.isLoading ||
          loading
        }
        showModal={showModal}
        title={
          this.isOnlinePaymentConfirmationModalSelected() ||
          isOnlinePaymentInProgress
            ? 'Collection Confirmation'
            : modalTitle
        }
        closeModal={() => {
          this.closeModal(false, false);
        }}
        modalTheme={modalTheme}
        loaderStyles={styles.loaderStyles}
      >
        <div className={`${styles.editPaymentDetailsModalWrapper}`}>
          {!this.isOnlinePaymentConfirmationModalSelected() &&
          !isOnlinePaymentInProgress ? (
            <div className={`${styles.amountDetailsSection}`}>
              {!this.isOnlinePaymentConfirmationModalSelected() &&
                !isOnlinePaymentInProgress &&
                this.renderShortPaymentSection()}

              <div className={`${styles.amountRow} l-row j-space-bet`}>
                <div className={`${styles.colLable}`}>Amount</div>
                <div className={`${styles.colValue}`}>
                  {roundOff(finalTotalAmount || 0)}
                </div>
              </div>

              {
                // <div className={`${styles.amountRow} l-row j-space-bet`}>
                //   <div className={`${styles.colLable}`}>TDS Applicable</div>
                //   <div
                //     className={`${styles.colValue}`}
                //     onClick={() => this.toggleTDSsection()}
                //   >
                //     {this.state.showTDSsection ? (
                //       <img src={selectEnabledUrl} alt="" />
                //     ) : (
                //       <img src={selectDisabledUrl} alt="" />
                //     )}
                //   </div>
                // </div>
              }

              {tdsApplied ? (
                <div className={`${styles.tdsAppliedSection}`}>
                  <div
                    className={`${styles.amountRow} ${styles.tdsPerc} l-row j-space-bet`}
                  >
                    <div className={`${styles.colLable}`}>
                      TDS Amount 2% (On total freight)
                    </div>
                    <div className={`${styles.colValue}`}>- Rs. 800</div>
                  </div>

                  <div className={`${styles.amountRow}`}>
                    <div className={`${styles.separatorLine}`} />
                    <div className="l-row j-space-bet">
                      <div className={`${styles.colLable}`}>Net Amount</div>
                      <div className={`${styles.colValue}`}>- Rs. 29,200</div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
          {showTDSsection ? (
            <div className={`${styles.tdsSection} l-row j-space-bet`}>
              <div className={`${styles.tdsInputWrapper}`}>
                <InputField
                  label=""
                  placeholder="Enter TIN no"
                  type="text"
                  value=""
                  disabled={false}
                  onChange={val => this.setTINNo(val)}
                />
              </div>
              <div
                className={`${styles.tdsApplyBtn} l-row j-center a-center`}
                onClick={() => this.applyTINno()}
              >
                Apply
              </div>
            </div>
          ) : null}

          <div className={`${styles.paymentModeSection}`}>
            {this.isOnlinePaymentConfirmationModalSelected() ||
            isOnlinePaymentInProgress ||
            changeNumberModal ? null : (
              <div
                className={`${styles.paymentModeBtnsWrapper} l-row j-space-bet`}
              >
                {this.isCashAllowed(allowedPaymentTypes) && (
                  <div
                    className={`${
                      styles.paymentModeBtn
                    } l-row j-center a-center cursor-p ${
                      paymentMode &&
                      paymentMode.toUpperCase() === paymentTypeMap.CASH.key
                        ? styles.paymentModeBtnSelected
                        : ''
                    }`}
                    onClick={() =>
                      this.showPaymentModeDetailsSection(
                        paymentTypeMap.CASH.key
                      )
                    }
                  >
                    {paymentTypeMap.CASH.displayValue}
                  </div>
                )}
                {this.isChequeAllowed(allowedPaymentTypes) &&
                showChequeDetailsOption ? (
                  <div
                    className={`${
                      styles.paymentModeBtn
                    } l-row j-center a-center cursor-p ${
                      paymentMode &&
                      paymentMode.toUpperCase() === paymentTypeMap.CHEQUE.key
                        ? styles.paymentModeBtnSelected
                        : ''
                    }`}
                    onClick={() =>
                      this.showPaymentModeDetailsSection(
                        paymentTypeMap.CHEQUE.key
                      )
                    }
                  >
                    {paymentTypeMap.CHEQUE.displayValue}
                  </div>
                ) : null}
                <div
                  className={`${
                    styles.paymentModeBtn
                  } l-row j-center a-center cursor-p ${
                    paymentMode &&
                    paymentMode.toUpperCase() ===
                      paymentTypeMap.BANK_TRANSFER.key
                      ? styles.paymentModeBtnSelected
                      : ''
                  }`}
                  onClick={() =>
                    this.showPaymentModeDetailsSection(
                      paymentTypeMap.BANK_TRANSFER.key
                    )
                  }
                >
                  {paymentTypeMap.BANK_TRANSFER.displayValue}
                </div>
                {/* <div
                  className={`${
                    styles.paymentModeBtn
                  } l-row j-center a-center cursor-p ${
                    paymentMode &&
                    paymentMode.toUpperCase() === paymentTypeMap.ONLINE.key
                      ? styles.paymentModeBtnSelected
                      : ''
                  }`}
                  onClick={() =>
                    this.showPaymentModeDetailsSection(
                      paymentTypeMap.ONLINE.key
                    )
                  }
                >
                  {paymentTypeMap.ONLINE.displayValue}
                </div> */}
              </div>
            )}
            {isLoading && <div className="center">Please wait...</div>}
            {showChequeDetailsSection ? (
              <div
                className={`${styles.chequeDetailsSection} ${
                  isLoading || editPaymentDetailsSubmitData.isLoading
                    ? styles.hide
                    : ''
                }`}
              >
                <div className={`${styles.chequeUploadDiv}`}>
                  {!chequeImage ? <p> Upload cheque image</p> : null}
                  <ImageUpload
                    id="chequeImage"
                    setImageFile={file => {
                      this.setChequeImageFile(file);
                    }}
                    uploadButtonString="UPLOAD IMAGE"
                    reUploadButtonString="RE-UPLOAD IMAGE"
                  />
                </div>
                {isChequeUploaded && (
                  <div>
                    <div className={`${styles.bankOptionsWrapper}`}>
                      <Select
                        label="Select Bank"
                        nameValStrings={this.bankNameValKeys}
                        optionsArrOfObj={bankData.data.val}
                        selectedOpt={selectedBank}
                        onSelect={(val, obj) => {
                          this.onBankSelect(val, obj);
                        }}
                        enableSearch={true}
                        disableNone={true}
                      />
                    </div>
                    {showOcrSection && (
                      <div className={`${styles.chequeNumberDetailsDiv}`}>
                        <span>Cheque Number</span>
                        <span className={`${styles.chequeNumberDisplay}`}>
                          {ocrChequeNumber}
                        </span>
                      </div>
                    )}
                    {showOcrSection && (
                      <div className={`${styles.chequeNumberDetailsDiv}`}>
                        <span>Confirm Cheque Number</span>
                        <span className={`${styles.chequeNumberDetails}`}>
                          <label htmlFor="yes" className={`${styles.radio}`}>
                            <input
                              type="radio"
                              id="yes"
                              name="isChequeNumberCorrect"
                              className={`${styles.hidden}`}
                              value="yes"
                              checked={isChequeNumberCorrect}
                              onChange={() =>
                                this.onChequeNumberRadioChange(true)
                              }
                            />
                            <span className={`${styles.label}`}></span>
                            <span className={`${styles.labelText}`}>
                              &thinsp;Yes
                            </span>
                          </label>
                          <span>&emsp;</span>
                          <label htmlFor="no" className={`${styles.radio}`}>
                            <input
                              type="radio"
                              id="no"
                              name="isChequeNumberCorrect"
                              className={styles.hidden}
                              value="no"
                              checked={!isChequeNumberCorrect}
                              onChange={() =>
                                this.onChequeNumberRadioChange(false)
                              }
                            />
                            <span className={`${styles.label}`}></span>
                            <span className={`${styles.labelText}`}>
                              &thinsp;No
                            </span>
                          </label>
                        </span>
                      </div>
                    )}
                    {!isChequeNumberCorrect ? (
                      <div>
                        <InputField
                          inputClassName={`${styles.chequeNumberInput}`}
                          id="inputChequeNumber"
                          allowedInputKeys="onlynumber"
                          maxLength="6"
                          value={chequeNo}
                          onChange={val => this.setChequeNo(val)}
                          placeholder={'Enter Correct Cheque Number'}
                        />
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
            ) : null}

            {showBankTransferDetailsSection ? (
              <div className="l-column">
                <div
                  className={`${styles.bankTransferDetailsSection} l-row j-space-bet`}
                >
                  <InputField
                    label=""
                    placeholder="Enter UTR/Reference No."
                    type="text"
                    allowedInputKeys="alphaNumeric"
                    maxLength="24"
                    value={transactionReferenceNo}
                    disabled={false}
                    onChange={val => {
                      this.setTransactionReferenceNo(val);
                      this.getUtrDetails();
                    }}
                  />
                </div>
                {isUtrNoFetched && (
                  <React.Fragment>
                    <div
                      className={`${styles.bankTransferDetailsSection} l-row j-space-bet`}
                    >
                      <InputField
                        label=""
                        placeholder="Enter Transaction Amount on UTR"
                        type="text"
                        allowedInputKeys="decimalnumber"
                        value={transferredAmount}
                        disabled={isUtrDetailPresent || false}
                        onChange={val => this.setTransferredAmount(val)}
                      />
                    </div>
                    <div className={`${styles.bankOptionsWrapper}`}>
                      <Select
                        label="Bank"
                        nameValStrings={this.rivigoBankNameValKeys}
                        optionsArrOfObj={rivigoBankData.data.val}
                        selectedOpt={selectedRivigoBank}
                        onSelect={(val, obj) => {
                          this.onRivigoBankSelect(val, obj);
                        }}
                        enableSearch={true}
                        disableNone={true}
                        displayAccessorFunction={
                          this.rivigoBanksToDisplayAccessor
                        }
                        filterFunction={this.rivigoBanksFilterOnSearch}
                        disabled={isUtrDetailPresent}
                      />
                    </div>
                    <ImageUpload
                      id="transactionScreenshot"
                      setImageFile={file =>
                        this.setTransactionScreenshotImageFile(file)
                      }
                      uploadButtonString="Upload Transaction Screenshot"
                      reUploadButtonString="Re-Upload Transaction Screenshot"
                    />
                  </React.Fragment>
                )}
              </div>
            ) : null}

            {this.isOnlinePaymentConfirmationModalSelected() &&
            !isOnlinePaymentInProgress ? (
              <div className="l-column">
                <div className={`${styles.infoText} l-row j-space-bet`}>
                  This will add ₹ {roundOff(totalAmount || 0)} to your
                  outstanding
                </div>
              </div>
            ) : null}

            {isOnlinePaymentInProgress && !changeNumberModal ? (
              <>
                <div className={`${styles.infoText} l-row j-space-bet`}>
                  {`A link has been sent to mobile number "${phoneNumberforLink}" for online payment`}
                </div>

                <div>
                  {!loading ? (
                    <Loader
                      message={`Payment Status: ${
                        isPaymentConfirmed ? 'Confirmed' : 'Pending'
                      }`}
                      inputLoaderUrl={
                        isPaymentConfirmed ? confirmedImgUrl : loaderImgUrl
                      }
                    />
                  ) : null}
                </div>
                <div
                  className={`${styles.submitBtnWrapper} l-row j-center a-center`}
                >
                  <div
                    className={`${styles.changeNumberBtn} l-row j-center a-center cursor-p`}
                    onClick={() =>
                      this.setState({
                        changeNumberModal: true,
                        changeNumberInput: ''
                      })
                    }
                  >
                    Change Mobile Number
                  </div>

                  <button
                    className={`${styles.resendBtn} l-row j-center a-center cursor-p`}
                    onClick={() => this.resendLink()}
                    disabled={resendBtnDisable}
                  >
                    Resend Link
                  </button>
                </div>
              </>
            ) : null}

            {changeNumberModal ? (
              <>
                <div className={`${styles.infoText}`}>
                  Add new mobile number to send link for online payment
                </div>
                <InputField
                  inputClassName={`${styles.shortPaymentInput}`}
                  id="shortPaymentAmount"
                  allowedInputKeys="phoneNumber"
                  value={changeNumberInput}
                  onChange={val => {
                    this.setState({
                      changeNumberInput: val
                    });
                  }}
                  placeholder={'Enter Mobile Number'}
                />
                <div
                  className={`${styles.submitBtnWrapper} l-row j-center a-center`}
                >
                  <div
                    className={`${styles.submitBtn} l-row j-center a-center cursor-p`}
                    onClick={() => this.sendLinkonNewMobile()}
                  >
                    Send
                  </div>
                  <div
                    className={`${styles.resendBtn} l-row j-center a-center cursor-p`}
                    onClick={() =>
                      this.setState({
                        changeNumberModal: false,
                        changeNumberInput: ''
                      })
                    }
                  >
                    Cancel
                  </div>
                </div>
              </>
            ) : null}

            {!isOnlinePaymentInProgress ? (
              <div
                className={`${styles.submitBtnWrapper} l-row j-center a-center`}
              >
                {paymentMode &&
                paymentMode.toUpperCase() === paymentTypeMap.ONLINE.key ? (
                  <div
                    className={`${styles.submitBtn} l-row j-center a-center cursor-p`}
                    onClick={() => this.initiatePayment()}
                  >
                    Initiate Payment
                  </div>
                ) : isOnlinePaymentInProgress ? null : (
                  <div
                    className={`${styles.submitBtn} l-row j-center a-center cursor-p`}
                    onClick={() => this.submitPaymentDetails()}
                  >
                    Submit
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </div>
      </Modal>
    );
  }
}

export default EditPaymentDetailsModal;
